import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TierProFilled icon
 *
 * @category Tier
 */
const TierProFilled = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M23.968 16.932c1.085 0 1.648 1.293.91 2.088L16.91 27.6c-.769.828-2.153.284-2.153-.845v-8.581c0-.686.556-1.242 1.242-1.242zM15.09 4.399c.768-.827 2.154-.283 2.154.846v8.581c0 .686-.558 1.242-1.244 1.242H8.033c-1.085 0-1.65-1.293-.912-2.088z"
        />
      </svg>
    );
  }
);

TierProFilled.displayName = 'TierProFilled';

export { TierProFilled };
